module.exports = __webpack_public_path__ + "img/logout.22a18f8c.svg";